/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  ActionCardProps,
  ActionsProps,
  Product,
  RightPanelTabs,
  RightPanelTabsConfiguration,
} from '@access-erp/common';
import { CardType, IRowNode } from '@access-erp/ui-components';
import { useMemo, useState } from 'react';

import History from '../components/History/History';
import { ProductTypeWithId } from '@/utils/data-helpers/types';
import { UserRole } from '@/config/roles.config';
import { EnvUtils } from '@/utils/env.utils';

type ActionButton = {
  config: ActionCardProps;
  isVisible: boolean;
};

interface UseRightPanelParams {
  selectedHeaderRows: IRowNode<ProductTypeWithId>[];
  userRole?: UserRole;
}

export function useRightPanel({ selectedHeaderRows, userRole }: UseRightPanelParams) {
  const [isVisibleBillingTypeModal, setIsVisibleBillingTypeModal] = useState(false);
  const [isVisibleDeleteConfirmModal, setIsVisibleDeleteConfirmModal] = useState(false);
  const [isVisibleProductMergeDefaultsModal, setIsVisibleProductMergeDefaultsModal] = useState(false);

  const isProductMergeDefaultsVisible =
    EnvUtils.isContractLineMergeEnabled() && userRole === UserRole.FULL_ACCESS;

  const actionButtons = useMemo<ActionButton[]>(
    () => [
      {
        config: {
          text: 'Change Billing Type',
          cardType: CardType.ACTION,
          product: Product.ContractsAndBilling,
          onClick: () => setIsVisibleBillingTypeModal(true),
        },
        isVisible: selectedHeaderRows.length > 0 &&
          (userRole === UserRole.ADMIN || userRole === UserRole.FULL_ACCESS),
      },
      {
        config: {
          text: 'Manage Product Merge Defaults',
          cardType: CardType.ACTION,
          product: Product.ContractsAndBilling,
          onClick: () => setIsVisibleProductMergeDefaultsModal(true),
        },
        isVisible: isProductMergeDefaultsVisible,
      },
    ],
    [selectedHeaderRows, isProductMergeDefaultsVisible],
  );

  const actionsParams: ActionsProps = {
    actionCards: {
      actions: actionButtons.filter((el) => el.isVisible).map((el) => el.config),
    },
  };

  const tabsConfiguration = useMemo<RightPanelTabsConfiguration>(
    () => ({
      [RightPanelTabs.ACTIONS]: actionsParams,
      History: {
        component: <History selectedProducts={selectedHeaderRows} />,
      },
    }),
    [selectedHeaderRows, isProductMergeDefaultsVisible],
  );

  return {
    tabsConfiguration,
    closeBillingTypeModal: () => setIsVisibleBillingTypeModal(false),
    closeDeleteConfirmModal: () => setIsVisibleDeleteConfirmModal(false),
    closeProductMergeDefaultsModal: () => setIsVisibleProductMergeDefaultsModal(false),
    isVisibleBillingTypeModal,
    isVisibleDeleteConfirmModal,
    isVisibleProductMergeDefaultsModal,
  };
}
